var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { staticClass: "mb10", attrs: { inline: true, size: "small" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "旧手机号" } },
            [
              _c("el-input", {
                attrs: { placeholder: "旧手机号", clearable: "" },
                model: {
                  value: _vm.query.oldPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "oldPhone", $$v)
                  },
                  expression: "query.oldPhone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "新手机号" } },
            [
              _c("el-input", {
                attrs: { placeholder: "新手机号", clearable: "" },
                model: {
                  value: _vm.query.newPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "newPhone", $$v)
                  },
                  expression: "query.newPhone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "操作人" } },
            [
              _c("el-input", {
                attrs: { placeholder: "操作人", clearable: "" },
                model: {
                  value: _vm.query.operator,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "operator", $$v)
                  },
                  expression: "query.operator",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        [
          _c("el-form-item", [
            _vm._v(
              "\n     " +
                _vm._s(this.customerInfo.customerName) +
                " - 福豆转移\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConvertFudou },
                },
                [_vm._v("转移福豆")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { data: _vm.list, border: "", stripe: "", size: "small" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "转移时间", width: "160" },
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "旧账号" } },
            [
              _c("el-table-column", {
                attrs: { prop: "oldEmpName", label: "姓名", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "oldPhone", label: "手机号", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oldTotalBefore",
                  label: "转前总福豆",
                  width: "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oldRemainBefore",
                  label: "转前剩余",
                  width: "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oldTotalAfter",
                  label: "转后总福豆",
                  width: "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oldRemainAfter",
                  label: "转后剩余",
                  width: "110",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "新账号" } },
            [
              _c("el-table-column", {
                attrs: { prop: "newEmpName", label: "姓名", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "newPhone", label: "手机号", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "newTotalBefore",
                  label: "转前总福豆",
                  width: "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "newRemainBefore",
                  label: "转前剩余",
                  width: "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "newTotalAfter",
                  label: "转后总福豆",
                  width: "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "newRemainAfter",
                  label: "转后剩余",
                  width: "110",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "operator", label: "操作人" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "mt10",
        attrs: {
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
          "current-page": _vm.query.page,
          "page-size": _vm.query.limit,
          total: _vm.total,
        },
        on: {
          "current-change": _vm.handlePageChange,
          "size-change": _vm.handleSizeChange,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "转移福豆",
            visible: _vm.dialog.visible,
            width: "760px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.dialog.form, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旧手机号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入旧手机号" },
                    on: { input: _vm.invalidatePreview },
                    model: {
                      value: _vm.dialog.form.oldPhone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.dialog.form,
                          "oldPhone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "dialog.form.oldPhone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新手机号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入新手机号" },
                    on: { input: _vm.invalidatePreview },
                    model: {
                      value: _vm.dialog.form.newPhone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.dialog.form,
                          "newPhone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "dialog.form.newPhone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.dialog.previewLoading,
                      },
                      on: { click: _vm.handlePreview },
                    },
                    [_vm._v("\n          确认\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dialog.preview
            ? _c(
                "div",
                { staticClass: "preview-box" },
                [
                  _c("el-divider", [_vm._v("转移结果预览")]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: { stripe: "", data: _vm.previewTable, border: "" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "label", label: "", width: "150" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "old", label: "旧账号" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "new", label: "新账号" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    disabled: !_vm.canConfirmTransfer,
                    loading: _vm.dialog.confirmLoading,
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("\n      确认转移\n    ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }